import { ViewEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'
import mixpanel from 'mixpanel-browser'

export class HomeMetric extends BaseMetric {
	static viewHome(routeName?: string): void {
		new ViewEvent('home', routeName).send(this.gtag, mixpanel)
	}
}
